module.exports = __webpack_public_path__ + "img/ic_icon_cvu_dni2.2c2ab7b8.png";